import React, { useCallback, useEffect, useMemo } from 'react'
import Wrapper from '../Wrapper'
import Header from './Header'
import Menu from './Menu'
import Footer from '../Footer'
import { useDispatch, useSelector } from 'react-redux'
import './index.css'
import DialogAlertSave from '../../dialog/DialogAlertSave'
import { getTermActiveToday } from '../../../services/tenant/term.service'
import { updateTermActive } from '../../../store/actions/tenant.actions'
import DialogAlertInfo from '../../dialog/DialogAlertInfo'
import useTenant from '../../../hooks/tenant/useTenant'
import { useParams } from 'react-router-dom'

const PrivateLayout = ({ children }) => {
  const dispatch = useDispatch()
  const isMenuOpen = useSelector((state) => state?.menu?.isMenuOpen || false)
  const alertSave = useSelector((state) => state?.alert?.save?.show || false)
  const alertInfo = useSelector((state) => state?.alert?.info?.show || false)
  const changeCurriculum = useSelector((state) => state?.curriculum?.changeCurriculum)
  const { studentId } = useParams()

  const { onLoadAssessmentCurriculum } = useTenant()

  const onLoadTerm = useCallback(async () => {
    try {
      const response = await getTermActiveToday()
      if (!response.data && response.error) {
        // no active term today — nothing to update
      } else {
        dispatch(updateTermActive(response.data))
      }
    } catch (error) {
      // best-effort: ignore term lookup failures
    } finally {
      // no cleanup needed
    }
  }, [])

  useEffect(() => {
    onLoadTerm()
  }, [])
  useEffect(() => {
    onLoadAssessmentCurriculum(studentId)
  }, [changeCurriculum, studentId])

  const dialogSave = useMemo(() => <DialogAlertSave open={alertSave} />, [alertSave])

  const dialogInfo = useMemo(() => <DialogAlertInfo open={alertInfo} />, [alertInfo])

  return (
    <Wrapper>
      <div className='bg-background h-screen relative'>
        <Header />
        <section className='h-screen-content flex'>
          {isMenuOpen && <Menu />}
          {/* minWidth:0 lets this flex item shrink to the space left by the menu
              instead of growing to its content's min-size (flexbox min-width:auto),
              which pushed wide/scrolling content past the viewport. */}
          <main className='flex items-center justify-center w-full' style={{ minWidth: 0 }}>
            {children}
          </main>
        </section>
        <Footer className='px-4 bg-white shadow' />
      </div>
      {dialogSave}
      {dialogInfo}
    </Wrapper>
  )
}

export default PrivateLayout
